import React, { Component } from 'react'
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { boolean } from '@storybook/addon-knobs';
import { Link } from "react-router-dom"
import AOS from 'aos';
import workspace1 from "../../assets/images/workspace1.png"
import workspace2 from "../../assets/images/workspace2.png"
import workspace3 from "../../assets/images/workspace3.png"
import workspace4 from "../../assets/images/workspace4.png"
import workspace5 from "../../assets/images/workspace5.png"
import arrowright from "../../assets/images/arrow-right.svg"
import fxconcept from "../../assets/images/fxconcept.png"
import videoIcon from "../../assets/images/videoIcon.svg"
import Button from "../../components/Button"

class About extends Component {
    componentDidMount() {
        // or simply just AOS.init();
        AOS.init({
          // initialise with other settings
          duration : 1000
        });
      }
    render() {

        const tooglesGroupId = 'Toggles';

        const getConfigurableProps = () => ({
            showArrows: boolean('showArrows', false, tooglesGroupId),
            showStatus: boolean('showStatus', false, tooglesGroupId),
            showThumbs: boolean('showThumbs', false, tooglesGroupId),
            showIndicators: boolean('showIndicators', false, tooglesGroupId),
        })

        return (
            <>
                <div className="about">
                    <div className="about-bg">
                        <div className="workspace">
                            <div className="white-circle"></div>
                        </div>
                        <div className="tt">
                            <Carousel autoPlay {...getConfigurableProps()} >
                                <div className="meee">
                                    <img src={workspace1} alt="HendrayFinvest workspace" className="yeee"/>
                                </div>
                                <div>
                                    <img src={workspace2} alt="HendrayFinvest workspace" className="yeee"/>
                                </div>
                                <div>
                                    <img src={workspace3} alt="HendrayFinvest workspace" className="yeee"/>
                                </div>
                                <div>
                                    <img src={workspace4} alt="HendrayFinvest workspace" className="yeee"/>
                                </div>
                                <div>
                                    <img src={workspace5} alt="HendrayFinvest workspace" className="yeee"/>
                                </div>
                            </Carousel>
                        </div>
                    </div>
                    <div className="about-text" data-aos="fade-up" data-aos-delay="80" data-aos-duration="1600">
                        <h4 className="main-color bold">ABOUT US</h4>
                        <h6>
                        We are a group of innovative and unique forex traders based in Africa; we trade everything represented on a chart. We evangelize the concepts of being participants in the global financial market and provide educational resources to interested individuals- teaching them how to be consistent and independent profitable traders.
                            <br /><br />
                            We are building a platform for the long term in a bid to enable an ecosystem that will set the standard of changing lives and enabling generations to come.
                        </h6>
                        <div className="see-more">
                            <Link to="/about">
                                <Button>
                                    <p>See more</p>
                                    <img src={arrowright} alt="arrow right" />
                                </Button>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="fx-concept">
                    <div data-aos="zoom-in-left" data-aos-delay="100" data-aos-duration="1500">
                        <h1 className="main-color">DON’T UNDERSTAND <br /> THE CONCEPT OF <br /> FOREX YET?</h1>
                        <div className="concept-button">
                            <Button>
                                <p className="main-color">Watch Video</p>
                                <img src={videoIcon} alt="video svg" />
                            </Button>
                        </div>
                    </div>
                    <div className="fxconcept-img">
                        <img src={fxconcept} alt="fx illustration" />
                    </div>
                </div>
            </>
        )
    }
}

export default About;